import React, { Component } from 'react'

class Module extends Component {
  render() {
    const { children, ...rest } = this.props
    return (
      <div {...rest}>
        { this.props.children }
      </div>
    )
  }
}

export default Module


// WEBPACK FOOTER //
// ./src/ui/components/Module.js